module.exports = global["rpDiffusion"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/index.js
// module id = 1503
// module chunks = 1